// extracted by mini-css-extract-plugin
module.exports = {"root":"root-17Tsj","content":"content-61Kxj","message":"message-dLVOz"};